import { FormattedMessage } from 'react-intl';

import { useEditContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-edit-context';
import { useFeatureSwitch } from '@xing-com/hub';
import { IconEdit, IconInfo } from '@xing-com/icons';

import { ARMSTRONG_V1, EP_MOBILE_EDIT } from '../../config/feature-switches';
import { EditBarBack } from '../edit-bar-back/edit-bar-back';
import { ManageUpdates } from '../manage-updates/manage-updates';
import { ToggleEditMode } from '../toggle-edit-mode/toggle-edit-mode';

import * as Styled from './edit-bar.styles';

type EditBarMobileProps = {
  displayBackButton: boolean;
  canEditOnMobile?: boolean;
  displayManageUpdates?: boolean;
};
export const EditBarMobile: React.FC<EditBarMobileProps> = ({
  displayBackButton,
  canEditOnMobile = false,
  displayManageUpdates = false,
}) => {
  const { isEditing } = useEditContext();

  const isArmstrong = useFeatureSwitch(ARMSTRONG_V1, false);
  const hasCanEditMobileFeatureSwitch = useFeatureSwitch(EP_MOBILE_EDIT, false);

  return (
    <Styled.EditBarMobile
      $displayCta={!!(canEditOnMobile || displayManageUpdates)}
      data-testid="edit-bar-mobile"
    >
      <Styled.BannerMobileContainer>
        <Styled.BannerMobile>
          {displayBackButton ? (
            <Styled.BackButtonContainer>
              <EditBarBack />
            </Styled.BackButtonContainer>
          ) : null}
          {canEditOnMobile || (displayManageUpdates && !isArmstrong) ? (
            <div className="ctaContainer">
              {canEditOnMobile ? <ToggleEditMode /> : null}
              {displayManageUpdates ? <ManageUpdates /> : null}
            </div>
          ) : null}
          <Styled.LabelContainer>
            {canEditOnMobile && hasCanEditMobileFeatureSwitch ? (
              <IconInfo height={24} width={24} className="editMobileIcon" />
            ) : (
              <IconEdit height={24} width={24} className="editMobileIcon" />
            )}
            <Styled.MobileInfo size="small">
              <span data-testid="edit-bar-mobile-label">
                <FormattedMessage
                  id={
                    canEditOnMobile && hasCanEditMobileFeatureSwitch
                      ? isEditing
                        ? 'EP_EDIT_INFO_EDIT_VIEW'
                        : 'EP_EDIT_INFO_VISITOR_VIEW'
                      : 'EP_EDIT_INFO_MOBILE'
                  }
                  values={{
                    span: (msg) => <span>{msg}</span>,
                  }}
                />
              </span>
            </Styled.MobileInfo>
          </Styled.LabelContainer>
        </Styled.BannerMobile>
      </Styled.BannerMobileContainer>
    </Styled.EditBarMobile>
  );
};
